import React, { Fragment } from 'react'
import { useHistory } from 'react-router'
import { Box } from '@material-ui/core'
import { useCore, getUserAgent, isIE } from 'hooks'
import Button from 'components/Button'
import { Box as Content, Container } from 'templates/DefaultTemplate'
import DefaultEntity from 'app/Default'

import { Svg } from './styles'
import UncompatibleNavigator from '../UncompatibleNavigator'

const Login: React.FC = () => {
  const { entity } = useCore()
  const history = useHistory()
  const Logo = entity.logo.default
  const userAgent = getUserAgent()
  const isInternetExplorer = isIE(userAgent)
  return (
    <Fragment>
      {isInternetExplorer && (
        <div className='uncompatible-navigator'>
          <UncompatibleNavigator />
        </div>
      )}
      <Container>
        <Content>
          <Box mt={3} mb={1}>
            {Logo && (
              <Svg>
                <Logo />
              </Svg>
            )}
            <Box mt={10}>
              <Button
                fullWidth
                size='large'
                color='primary'
                onClick={() => history.push(DefaultEntity.route.LOGIN.path)}
                disabled={isInternetExplorer}
              >
                Sou cadastrado
              </Button>
              <Box mt={1}>
                <Button
                  fullWidth
                  size='large'
                  variant='outlined'
                  onClick={() => history.push(DefaultEntity.route.VERIFY_STATUS.path)}
                  disabled={isInternetExplorer}
                >
                  Quero me cadastrar
                </Button>
              </Box>
            </Box>
          </Box>
        </Content>
      </Container>
    </Fragment>
  )
}

export default Login
